/**
 * Render autocomplete
 *
 * @param {object} options
 * @param {string} options.value - The value of the autocomplete item.
 * @param {string} options.type - The type of the autocomplete item.
 * @param {number} options.index - The index of the autocomplete item in the list.
 * @param {string} options.title - The title of the autocomplete item.
 * @returns {string} The HTML string for the autocomplete item.
 */
export default function renderAutocomplete({ value, type, index, title }) {
  const isHistory = type === 'history';

  return `
    <div
      class="f-autocompleteItem js-autocompleteItem"
      data-value="${value}"
      data-type="${type}"
      data-automation-id="search-proposal-${isHistory ? 'historic-' : ''}list-${index}">
      <button
        tabindex="-1"
        type="button"
        class="f-autocompleteButton ${isHistory ? 'f-autocompleteButton--history' : ''} js-autocompleteItemTitle">
        <span>${title}</span>
      </button>
      ${
        isHistory
          ? `
        <button
          tabindex="-1"
          type="button"
          class="f-autocompleteButton f-autocompleteButton--remove js-autocompleteHistoryRemove"
          data-automation-id="search-proposal-historic-list-remove-button">
        </button>
      `
          : ''
      }
    </div>
  `;
}
